<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <h4 class="mb-0 text-uppercase d-none d-lg-inline-block">Meter Management</h4>
      </div>
    </nav>

    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <b-form-group label="Select Site">
                    <b-form-select
                      v-model="selectedSiteId"
                      :options="siteOptions"
                      @change="fetchMeterResets"
                      placeholder="Choose a site"
                    />
                  </b-form-group>
                </div>
                <div class="col-md-6 text-right">
                  <b-button
                      v-if="selectedSiteId"
                      variant="primary"
                      @click="openModal">
                        Reset a meter
                    </b-button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table :items="meterResets" :fields="tableFields" striped hover>
              </b-table>
            </div>

            <div class="card-footer border-0 my-2" v-if="pagination.total">
              <b-pagination
                align="right"
                @input="page => fetchMeterResets(page)"
                :total-rows="pagination.total"
                v-model="currentPage"
                :per-page="pagination.per_page || 10"
              />
            </div>
            <div v-else>
              <h4 class="py-5 text-center">No records available</h4>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Meter Reset Modal -->
      <b-modal ref="addMeterReset" id="addMeterReset" title="Reset a meter" centered hide-footer>
        <b-form @submit.prevent="submitMeterReset">
          <b-form-group label="Barcode">
            <b-form-input v-model="resetForm.barcode" required />
          </b-form-group>

          <b-form-group label="New Meter Reading">
            <b-form-input type="number" v-model="resetForm.new_meter_reading" required />
          </b-form-group>

          <div class="text-center">
            <b-button type="submit" variant="success">Submit</b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      selectedSiteId: null,
      currentPage: 1,
      resetForm: {
        barcode: '',
        new_meter_reading: null
      },
      errors: {},
      tableFields: [
        { key: 'lot_no', label: 'Lot' },
        { key: 'barcode', label: 'Barcode' },
        { key: 'original_meter_reading', label: 'Original Reading' },
        { key: 'new_meter_reading', label: 'New Reading' },
        { key: 'created_by', label: 'Created By' },
        { key: 'created_on', label: 'Created On' }
      ]
    }
  },

  computed: {
    ...mapGetters('coprops', ['coPropList']),
    ...mapGetters('meterReset', ['meterResets', 'meterResetPagination']),

    siteOptions() {
      return (this.coPropList.data || []).map(site => ({
        value: site.id,
        text: site.name
      }));
    },

    pagination() {
      return this.meterResetPagination || {}
    }
  },

  methods: {
    ...mapActions('coprops', ['ALL_CO_PROP_LIST']),
    ...mapActions('meterReset', ['FETCH_METER_RESETS', 'ADD_METER_RESET']),

    fetchMeterResets(page = 1) {
      if (!this.selectedSiteId) return
      this.currentPage = page
      this.FETCH_METER_RESETS({ site_id: this.selectedSiteId, page })
    },

    openModal() {
      if (this.$refs.addMeterReset) {
        this.$refs.addMeterReset.show();
      } else {
        console.warn('Modal ref not found');
      }
    },

    closeModal() {
      if (this.$refs.addMeterReset) {
        this.$refs.addMeterReset.hide();
      } else {
        console.warn('Modal ref not found');
      }
    },

    

    submitMeterReset() {
      this.errors = {}
      const { barcode, new_meter_reading } = this.resetForm

      if (!barcode) {
        this.errors.barcode = 'Barcode is required.'
      }
      if (new_meter_reading === null || new_meter_reading < 0) {
        this.errors.new_meter_reading = 'Enter a valid meter reading.'
      }
      if (Object.keys(this.errors).length > 0) return

      const payload = {
        site_id: this.selectedSiteId,
        barcode,
        new_meter_reading
      }

      this.ADD_METER_RESET(payload)
      .then((res) => {
        console.log(res);
        if (res.status) {
          this.closeModal();
          this.resetForm = { barcode: '', new_meter_reading: null };
          this.SUCCESS_TOAST_MSG(res.message || 'Meter reset successfully');
        } else {
          this.ERROR_TOAST_MSG(res.message || 'Something went wrong');
        }
      })
      .catch((err) => {
          const message = err.body.message || 'Failed to add meter reset.';
          this.ERROR_TOAST_MSG(message);
        }); 
    }
  },

  created() {
    this.ALL_CO_PROP_LIST()
  },

  beforeDestroy() {
  this.$store.commit('meterReset/CLEAR_METER_RESETS');
}
}
</script>


// WEBPACK FOOTER //
// src/pages/Admin/meterReset.vue